interface User {
    id: string;
    username: string;
    email: string;
    avatar?: string;
}

interface LoginResponse {
    user: User;
    token: string;
}

interface AuthState {
    user: User | null;
    token: string | null;
    isAuthenticated: boolean;
}

const mockUser: User = {
    id: "1",
    username: "testuser",
    email: "test@example.com",
    avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=test",
};

const mockToken = "mock-jwt-token";

export const authApi = {
    login: async (username: string, password: string): Promise<LoginResponse> => {
        // شبیه‌سازی تأخیر شبکه
        await new Promise((resolve) => setTimeout(resolve, 1000));

        if (username === "test" && password === "test") {
            return {
                user: mockUser,
                token: mockToken,
            };
        }
        throw new Error("نام کاربری یا رمز عبور اشتباه است");
    },

    logout: async (): Promise<void> => {
        await new Promise((resolve) => setTimeout(resolve, 500));
    },

    getCurrentUser: async (): Promise<User> => {
        await new Promise((resolve) => setTimeout(resolve, 500));
        return mockUser;
    },

    getAuthState: (): AuthState => {
        const token = localStorage.getItem("auth_token");
        const userStr = localStorage.getItem("auth_user");
        const user = userStr ? JSON.parse(userStr) : null;

        return {
            user,
            token,
            isAuthenticated: !!token && !!user,
        };
    },
};
